import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@antimatterhq/ui/components/select';

type UpdateNotablesStateSelectProps = {
  onSelect: (value: string) => void;
  disabled?: boolean;
};
export const UpdateNotablesStateSelect = ({
  onSelect,
  disabled = false,
}: UpdateNotablesStateSelectProps) => {
  return (
    <Select onValueChange={onSelect} disabled={disabled}>
      <SelectTrigger className="h-8 w-max">
        <SelectValue placeholder="Close as" />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="ClosedAsFalsePositive">False positive</SelectItem>
        <SelectItem value="ClosedAsBenignPositive">Benign positive</SelectItem>
        <SelectItem value="ClosedAsTruePositiveResolved">
          True positive resolved
        </SelectItem>
        <SelectItem value="ClosedAsExported">Exported</SelectItem>
      </SelectContent>
    </Select>
  );
};
